'use server'

import { cookies } from 'next/headers'
import { revalidatePath } from 'next/cache'

export async function logoutAction() {
  console.log('🍪 [LogoutAction] Starting server-side logout...')
  
  try {
    const cookieStore = await cookies()
    console.log('🍪 [LogoutAction] Cookie store obtained')
    
    // Получаем ВСЕ cookies и удаляем auth-related
    const allCookies = cookieStore.getAll()
    console.log(`🍪 [LogoutAction] Found ${allCookies.length} total cookies`)
    
    // Список всех возможных auth-related cookies
    const authCookiePatterns = [
      'accessToken',
      'refreshToken',
      'sessionId',
      'userId',
      'auth-token',
      'session',
      'jwt',
      'token',
      'user',
      'auth',
      // Добавьте другие названия cookies, если используете
    ]

    let deletedCount = 0

    // Удаляем по названию
    authCookiePatterns.forEach(pattern => {
      const cookie = cookieStore.get(pattern)
      if (cookie) {
        console.log(`  - Deleting cookie by name: ${pattern}`)
        cookieStore.delete(pattern)
        deletedCount++
      }
    })

    // Удаляем cookies, содержащие auth-паттерны в названии
    allCookies.forEach(cookie => {
      const lowerName = cookie.name.toLowerCase()
      const isAuthRelated = authCookiePatterns.some(pattern => 
        lowerName.includes(pattern.toLowerCase())
      )
      
      if (isAuthRelated) {
        console.log(`  - Deleting cookie by pattern: ${cookie.name}`)
        cookieStore.delete(cookie.name)
        deletedCount++
      }
    })

    console.log(`✅ [LogoutAction] Deleted ${deletedCount} cookies`)

    // КРИТИЧНО: Revalidate все пути для очистки серверного кеша
    revalidatePath('/', 'layout')
    console.log('✅ [LogoutAction] Revalidated root layout')

    return { success: true, deletedCookies: deletedCount }
  } catch (error) {
    console.error('❌ [LogoutAction] Error during logout:', error)
    console.error('❌ [LogoutAction] Error details:', {
      message: error instanceof Error ? error.message : 'Unknown error',
      stack: error instanceof Error ? error.stack : undefined,
    })
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error' 
    }
  }
}
